var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.742c0 5.381-4.395 9.743-9.818 9.743a9.835 9.835 0 0 1-4.746-1.212L0 20l1.772-5.227a9.64 9.64 0 0 1-1.409-5.03C.363 4.361 4.76 0 10.182 0 15.605 0 20 4.362 20 9.742zm-9.818-8.19c-4.552 0-8.255 3.674-8.255 8.19 0 1.793.584 3.452 1.573 4.803l-1.032 3.042 3.172-1.009a8.25 8.25 0 0 0 4.542 1.355c4.551 0 8.255-3.674 8.255-8.19 0-4.517-3.703-8.191-8.255-8.191zm4.958 10.434c-.06-.1-.221-.16-.462-.278-.24-.12-1.424-.698-1.644-.777-.22-.08-.382-.12-.542.12-.16.238-.621.776-.762.935-.14.16-.28.18-.522.06-.24-.119-1.015-.371-1.935-1.185-.715-.633-1.198-1.414-1.339-1.653-.14-.24-.014-.368.106-.487.108-.107.24-.279.361-.418.12-.14.16-.24.24-.399.081-.16.041-.298-.02-.418-.06-.12-.541-1.295-.742-1.773-.2-.478-.4-.398-.541-.398-.14 0-.3-.02-.461-.02-.16 0-.422.06-.642.299-.22.239-.842.816-.842 1.991 0 1.175.862 2.31.982 2.47.12.159 1.665 2.649 4.111 3.605 2.447.956 2.447.637 2.889.597.44-.04 1.423-.578 1.625-1.135.2-.558.2-1.036.14-1.136z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.875afc306107e506a644fe6dfe186279.svg";
export { ForwardRef as ReactComponent };